/** @module Enums */ /** typedoc */
var ApplicationEnum;
(function (ApplicationEnum) {
    ApplicationEnum["Artist"] = "Artist";
    ApplicationEnum["Auth0"] = "Auth0";
    ApplicationEnum["DesktopV2"] = "DesktopV2";
    ApplicationEnum["GuestSite"] = "GuestSite";
    ApplicationEnum["Core"] = "Core";
    ApplicationEnum["Library"] = "Library";
    ApplicationEnum["Projects"] = "Projects";
    ApplicationEnum["Billing"] = "Billing";
    ApplicationEnum["Account"] = "Account";
    ApplicationEnum["Dashboard"] = "Dashboard";
    ApplicationEnum["Distribution"] = "Distribution";
    ApplicationEnum["RootApp"] = "RootApp";
    ApplicationEnum["SamplesIngestionWizard"] = "SamplesIngestionWizard";
    ApplicationEnum["SamplesMarketplace"] = "SamplesMarketplace";
    ApplicationEnum["SamplesPlugin"] = "SamplesPlugin";
    ApplicationEnum["Services"] = "Services";
    ApplicationEnum["ServicesMarketplace"] = "ServicesMarketplace";
    ApplicationEnum["Web"] = "Web";
    ApplicationEnum["Sessions"] = "Sessions";
    ApplicationEnum["PluginsMarketplace"] = "PluginsMarketplace";
    ApplicationEnum["Messages"] = "Messages";
    ApplicationEnum["ProfileSetup"] = "ProfileSetup";
    ApplicationEnum["Chromatic"] = "Chromatic";
    ApplicationEnum["Network"] = "Network";
    ApplicationEnum["Profile"] = "Profile";
    ApplicationEnum["SynchroArtsApp"] = "SynchroArtsApp";
    ApplicationEnum["SynchroArtsGuestSite"] = "SynchroArtsGuestSite";
})(ApplicationEnum || (ApplicationEnum = {}));

export { ApplicationEnum };
